import { useDispatch, useSelector } from 'react-redux';
import { Form, Modal, Button } from 'react-bootstrap';

/* import function from store folder */
import { resetModel } from '../../../../store/components/modelSlice';
import { postBatterySendBouns } from '../../../../services/dashboard/battery';
import { message } from 'antd';
import { useState } from 'react';

const SendBonusModel = () => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.model);
    const [wantBonus, setWantBonus] = useState('補發'); 
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showModal, setShowModal] = useState(true);

    const confirmation = () => {
        const payload = {
            vehicleRewardPointsId: data.vehicleRewardPointsId,
            bouns: data.wantBonus,
            remark: wantBonus,
        };
        postBatterySendBouns(payload)
            .then(response => {
                cancelHandler();
                message.success('已發送紅利，請查詢發送結果確認');
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    const cancelHandler = () => {
        dispatch(resetModel());
        setShowModal(true);
    };    

    const handleSendBonus = () => {
        setShowModal(false);
        setShowConfirmationModal(true);
    };

    return (
        <>
            <Modal className='activity-list-model' show={ showModal } onHide={ cancelHandler } centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="message-container">
                        <Form className='model-form-container'>
                            <Form.Group className='model-form-group'>
                                <Form.Label>點數</Form.Label>
                                <Form.Control className='model-form-content' name='bonus' type="number" value={data.wantBonus} disabled/>
                            </Form.Group>
                            <Form.Group className='model-form-group'>
                                <Form.Label>備註</Form.Label>
                                <Form.Control className='model-form-content' maxLength={50} name='bonus' type="text" value={wantBonus} onChange={(e) => setWantBonus(e.target.value)}/>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className="button-container">
                        <Button variant="secondary" data-shadow onClick={ cancelHandler }>關閉</Button>
                        <Button variant="primary" data-shadow onClick={ handleSendBonus }>確認發送</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={ showConfirmationModal } onHide={ cancelHandler } centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="message-container-error">請確認是否要手動給予點數{data.wantBonus}點，確認後將進行給點！</div>
                    <div className="button-container">
                        <Button variant="secondary" onClick={ cancelHandler }>取消</Button>
                        <Button variant="primary" onClick={ confirmation }>確認</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default SendBonusModel;
